import { StatesAgent } from "src/constants/enums";
import { ParamsApi } from "src/models/api/paramsApi";


export const exportExcel = async (url: string, filter?: any) => {

    const cleanedFilter: Record<string, string> = {};

    if (filter && typeof filter === 'object') {
        for (const key in filter) {
            const value = filter[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanedFilter[key] = value;
            }
        }
    }

    const queryString = new URLSearchParams(cleanedFilter).toString();
    const finalUrl = url + (queryString ? '?' + queryString : '');

    const response = await fetch(finalUrl, {
        method: 'GET',
        headers: {
            'X-Authorization': sessionStorage.getItem('token') || '',
        },
    });

    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
        const blob = await response.blob();
        return { isFile: true, data: blob };
    }

    const json = await response.json();
    return { isFile: false, data: json };
};


export const exportRewardsExcel = async (url: string) => {

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'X-Authorization': sessionStorage.getItem('token') || '',
        },
    });

    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
        const blob = await response.blob();
        return { isFile: true, data: blob };
    }

    const json = await response.json();
    return { isFile: false, data: json };
};